/**
 * Feature flags:
 *
 * - 기능을 비활성화하려면 어떤 flag든 `false`로 설정하세요.
 * - 코드베이스에서 어떤 기능들을 채택하고 있는지 알아보세요.
 * - 구현을 찾으려면 코드베이스에서 flag를 검색하세요.
 *
 * 기능 설명: https://www.remotion.dev/docs/editor-starter/features
 */

// Action row
export const FEATURE_DRAW_SOLID_TOOL = true;
export const FEATURE_DRAW_BLUR_TOOL = true;
export const FEATURE_CREATE_TEXT_TOOL = true;
export const FEATURE_IMPORT_ASSETS_TOOL = true;
export const FEATURE_DOWNLOAD_STATE = true;
export const FEATURE_LOAD_STATE = true;
export const FEATURE_SAVE_BUTTON = true;
export const FEATURE_UNDO_BUTTON = true;
export const FEATURE_REDO_BUTTON = true;

// Timeline
export const FEATURE_TIMELINE_ZOOM_SLIDER = true;
/* 심각한 성능 이슈 있음 해결해야함 */
export const FEATURE_FILMSTRIP = false;
/* FILMSTRIP V2: 에셋 단위 프레임 추출로 성능 개선 (기존 FEATURE_FILMSTRIP 대신 사용) */
export const FEATURE_FILMSTRIP_V2 = true;
export const FEATURE_WAVEFORM = true;
/* 심각한 성능 이슈 있음 해결해야함 */
export const FEATURE_VIDEO_WAVEFORM = false;
export const FEATURE_AUDIO_WAVEFORM_FOR_VIDEO_ITEM = false;
export const FEATURE_TIMELINE_VOLUME_CONTROL = true;
export const FEATURE_DROP_ASSETS_ON_TIMELINE = true;
export const FEATURE_AUDIO_FADE_CONTROL = false;
export const FEATURE_VISUAL_FADE_CONTROL = false;
export const FEATURE_SPLIT_ITEM = true;
export const FEATURE_HIDE_TRACKS = true;
export const FEATURE_LOCK_TRACKS = true;
export const FEATURE_MAGNETIC_TRACKS = true;
export const FEATURE_MAX_TRIM_INDICATORS = true;
export const FEATURE_MUTE_TRACKS = true;
/* 버그 있음 제대로 동작하고 있지 않는 기능 */
export const FEATURE_ROLLING_EDITS = false;
export const FEATURE_TIMELINE_MARQUEE_SELECTION = true;
export const FEATURE_FOLLOW_PLAYHEAD_WHILE_PLAYING = true;
export const FEATURE_RESIZE_TIMELINE_PANEL = true;
export const FEATURE_TIMELINE_SNAPPING = true;
export const FEATURE_SKIMMING = true;
export const FEATURE_LINKING = true;

// Inspector
export const FEATURE_SWAP_COMPOSITION_DIMENSIONS_BUTTON = true;
export const FEATURE_SOURCE_CONTROL = true;
export const FEATURE_ALIGNMENT_CONTROL = true;
export const FEATURE_POSITION_CONTROL = true;
export const FEATURE_DIMENSIONS_CONTROL = true;
export const FEATURE_KEEP_ASPECT_RATIO_CONTROL = true;
export const FEATURE_BORDER_RADIUS_CONTROL = true;
export const FEATURE_OPACITY_CONTROL = true;
export const FEATURE_TEXT_ALIGNMENT_CONTROL = true;
export const FEATURE_FONT_FAMILY_CONTROL = true;
export const FEATURE_FONT_FAMILY_DROPDOWN_RENDER_IN_FONT = true;
export const FEATURE_CHANGE_FONT_FAMILY_ON_HOVER = true;
export const FEATURE_FONT_STYLE_CONTROL = true;
export const FEATURE_FONT_FAMILY_CONTROLS_PREVIEW_ON_HOVER = true;
export const FEATURE_CHANGE_FONT_STYLE_ON_HOVER = true;
export const FEATURE_TEXT_FONT_SIZE_CONTROL = true;
export const FEATURE_TEXT_VALUE_CONTROL = false;
export const FEATURE_COLOR_CONTROL = true;
export const FEATURE_ROTATION_CONTROL = true;
export const FEATURE_ROTATE_90_DEGREES_BUTTON = true;
export const FEATURE_TEXT_LINE_HEIGHT_CONTROL = true;
export const FEATURE_TEXT_LETTER_SPACING_CONTROL = true;
export const FEATURE_TEXT_DIRECTION_CONTROL = false;
export const FEATURE_PLAYBACKRATE_CONTROL = true;
export const FEATURE_VOLUME_CONTROL = true;
export const FEATURE_TOKENS_CONTROL = true;
export const FEATURE_CAPTIONS_PAGE_DURATION_CONTROL = true;
export const FEATURE_CAPTIONS_HIGHLIGHT_COLOR_CONTROL = true;
export const FEATURE_TEXT_STROKE_WIDTH_CONTROL = true;
export const FEATURE_TEXT_STROKE_COLOR_CONTROL = true;
export const FEATURE_TEXT_MAX_LINES_CONTROL = true;
export const FEATURE_BLUR_AMOUNT_CONTROL = true;

// Playback
export const FEATURE_JUMP_TO_START_BUTTON = false;
export const FEATURE_JUMP_TO_END_BUTTON = false;
export const FEATURE_JUMP_TO_PREVIOUS_FRAME = true;
export const FEATURE_JUMP_TO_PREVIOUS_CLIP = true;
export const FEATURE_JUMP_TO_NEXT_CLIP = true;
export const FEATURE_JUMP_TO_NEXT_FRAME = true;
export const FEATURE_FULLSCREEN_CONTROL = true;
export const FEATURE_MUTE_BUTTON = true;
export const FEATURE_LOOP_BUTTON = true;

// Canvas
export const FEATURE_CROPPING = true;
export const FEATURE_DOUBLE_CLICK_TO_CROP = true;
export const FEATURE_CROP_BACKGROUNDS = true;
export const FEATURE_SHIFT_AXIS_LOCK = true;
export const FEATURE_SHIFT_KEY_TO_OVERRIDE_ASPECT_RATIO_LOCK = false;
export const FEATURE_CANVAS_MARQUEE_SELECTION = true;
export const FEATURE_DROP_ASSETS_ON_CANVAS = true;
export const FEATURE_CANVAS_ZOOM_CONTROLS = true;
export const FEATURE_CANVAS_ZOOM_GESTURES = true;
export const FEATURE_CANVAS_ZOOM_KEYBOARD_SHORTCUTS = true;
export const FEATURE_BRING_TO_FRONT = true;
export const FEATURE_SEND_TO_BACK = true;

// Behaviors
export const FEATURE_CUT_LAYERS = true;
export const FEATURE_COPY_LAYERS = true;
export const FEATURE_DUPLICATE_LAYERS = true;
export const FEATURE_PASTE_TEXT = true;
export const FEATURE_PASTE_ASSETS = true;
// FEATURE_CACHE_ASSETS_LOCALLY: 디버그 패널의 Prefetch 토글로 대체됨 (load-to-blob-url.ts의 isPrefetchEnabled)
export const FEATURE_LOAD_STATE_FROM_URL = true;
export const FEATURE_WARN_ON_LONG_RUNNING_PROCESS_IN_PROGRESS = true;

// Keyboard Shortcuts
// First-party WorkSaveButton owns Cmd/Ctrl+S. Never save an unrelated browser-local document.
export const FEATURE_SAVE_SHORTCUT = false;
export const FEATURE_UNDO_SHORTCUT = true;
export const FEATURE_REDO_SHORTCUT = true;
export const FEATURE_SELECT_ALL_SHORTCUT = true;
export const FEATURE_DELETE_SHORTCUT = true;
export const FEATURE_BACKSPACE_TO_DELETE = true;
export const FEATURE_SNAPPING_SHORTCUT = true;
export const FEATURE_CLIP_TRIM_SHORTCUTS = true;
export const FEATURE_ARROW_KEY_MOVE = true;

// Captioning
export const FEATURE_CAPTIONING = true;

// Rendering
export const FEATURE_RENDERING = true;
export const FEATURE_RENDERING_CODEC_SELECTOR = true;
